import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=7ff27f9e&scoped=true&"
import script from "./exercise.vue?vue&type=script&lang=js&"
export * from "./exercise.vue?vue&type=script&lang=js&"
import style0 from "./exercise.vue?vue&type=style&index=0&id=7ff27f9e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff27f9e",
  null
  
)

export default component.exports